document.addEventListener('DOMContentLoaded', function () {
    const secondButton = document.querySelector('.additional-class');
    secondButton.style.transform = 'scale(1)';
    // const observer = new MutationObserver(function (mutations) {
    //     let buttonCount = 0;

    //     mutations.forEach(function (mutation) {
    //         mutation.addedNodes.forEach(function (node) {
    //             if (node.classList && node.classList.contains('GiftWizard-gift-button')) {
    //                 buttonCount++;

    //                 if (buttonCount === 2) {
    //                     node.classList.add('additional-class');
    //                     node.style.transform = 'scale(1)'; 
    //                     node.style.transition = 'transform 0.5s ease'; 
    //                 }
    //             }
    //         });
    //     });
    // });
    // observer.observe(document.body, { childList: true, subtree: true });

    // window.addEventListener('scroll', function () {
    //     if (secondButton) {
    //         const scrollPosition = window.scrollY + window.innerHeight;

    //         if (scrollPosition >= 1620) { // Aquí es donde comparas con el valor específico
    //             secondButton.style.transform = 'scale(1)';
    //         } else {
    //             secondButton.style.transform = 'scale(0)'; 
    //         }
    //     }
    // });
});